(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rxjs"));
	else if(typeof define === 'function' && define.amd)
		define("rxjsCreateTween", ["rxjs"], factory);
	else if(typeof exports === 'object')
		exports["rxjsCreateTween"] = factory(require("rxjs"));
	else
		root["rxjsCreateTween"] = factory(root["Rx"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_rxjs__) {
return 